import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import SlefData from "./components/slefData"
import MyOrder from "./components/order"
import MyAddress from "./components/address"
import MyShop from "./components/shop"
import MyWallet from "./components/wallet"
import ShopAdmin from "./shopAdmin"
import { useNavigate } from "react-router";
import { getQueryParam } from "../../utils/getUrlParamsLegacy";
import { createLoginSuccessAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { showLoding } from "../../utils/tool";
import { AuthGetInviteCode, AuthGetInviteCodeGenerate, AuthLogout } from "../../API/login";
import { Tooltip, message } from "antd";
import copy from "copy-to-clipboard";
import { getUserInfo } from "../../API";
import icon6 from "../../assets/image/icon6.png"

const ComponentName: React.FC = () => {
  const token = useSelector((state: any) => state?.token)
  const [tabIndex, setTabIndex] = React.useState<number>(Number(getQueryParam("tab")) || 0);
  const navigate = useNavigate()
  let dispatch = useDispatch();

  const [invitationCode, setInvitationCode] = React.useState<string>("")
  const handleAuthGetInviteCode = async () => {
    showLoding(true);
    try {
      const res: any = await AuthGetInviteCodeGenerate();
      if (res.code === 200) {
        setInvitationCode(res.data.invitationCode)
      }
    } catch (error) {
      console.log(error);
    }
    showLoding(false);
  };

  useEffect(() => {
    if (!token) {
      return
    }
    handleAuthGetInviteCode()
    handleUserInfo()
  }, [token]);

  const [userInfo, setUserInfo]: any = React.useState({});
  const handleUserInfo = () => {
    getUserInfo().then((res) => {
      setUserInfo(res.data);
    }).catch((err) => {
    });
  }

  return (
    <div className="">
      <TopBar />

      <div className="w-[960px] mx-auto h5:w-full h5:px-[16px]">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">帳戶詳細資料</div>
        </div>
        <br />
        <div className="flex items-center px-[20px] py-[26px] rounded-md relative h5:px-16 "
          style={{
            background: `url(${icon6})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
          }}>
          <div className="flex-1">
            <div className="text-[#595959] text-[16px] pb-10 flex items-center ">
              當前會員等級
              <Tooltip title="已實名,點擊查看詳情">
                <img src={require("../../assets/image/icon27.png")}
                  className="w-[20px] ml-10 cursor-pointer"
                  onClick={() => {
                    navigate('/account/approve')
                  }
                  }
                  alt="" />
              </Tooltip>
            </div>
            <div className="text-[#181512] text-[26px] font-bold">
              {userInfo?.membershipLevelDesc || '普通會員'}
            </div>
          </div>
          <div className="">
            {/* <div className="bg-[#6d6e71] rounded-[4px] inline-block px-[30px] py-[12px] text-[#fff] text-[16px] cursor-pointer
                    hover:bg-[#000] h5:px-[20px]"
              onClick={() => {
                copy(window.location.origin + '/login?invitationCode=' + invitationCode);
                message.success("已複製邀請鏈接");
              }}
            >
              複製邀請鏈接
            </div> */}
          </div>
          <div className={userInfo?.authenticated ? 'hidden' : 'block'}>
            <div className="absolute right-[0px] top-[0px] left-0 bottom-0 bg-[#0009] rounded-md blur-[2px]"></div>
            <div className="absolute right-[0px] top-[0px] left-0 bottom-0 pt-[26px] cursor-pointer"
              onClick={() => {
                navigate('/account/approve')
              }}
            >
              <img src={require("../../assets/image/icon27.png")}
                className="w-[46px] block mx-auto"
                alt="" />
              <div className="text-[#e0c398] text-[16px] text-center">實名認證後即享更多相關服務，點擊前往</div>
            </div>
          </div>
        </div>
        {/* <div className="text-[#181512] text-[44px] font-bold text-center">會員中心</div> */}
        <div className="flex pt-[90px] h5:pt-[70px] h5:block">
          <div className="w-[300px] pr-[40px] h5:w-full h5:pr-[0px]">
            <div className="pb-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => setTabIndex(0)}
            >
              帳戶詳細資料
              <div className="flex-1"></div>
              <img src={require('../../assets/image/icon25.png')}
                className={`${tabIndex === 0 ? 'block' : 'hidden'} w-[18px]`}
                alt="" />
            </div>
            <div className="py-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => {
                if (userInfo?.enableShop) {
                  setTabIndex(1)
                } else {
                  message.warning("請先開通店鋪")
                }
              }}
            >
              設置店鋪
              <div className="flex-1"></div>
              <img src={require('../../assets/image/icon25.png')}
                className={`${tabIndex === 1 ? 'block' : 'hidden'} w-[18px]`}
                alt="" />
            </div>
            <div className="py-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => {
                if (userInfo?.enableShop) {
                  setTabIndex(5)
                } else {
                  message.warning("請先開通店鋪")
                }
              }}
            >
              店鋪管理
              <div className="flex-1"></div>
              <img src={require('../../assets/image/icon25.png')}
                className={`${tabIndex === 5 ? 'block' : 'hidden'} w-[18px]`}
                alt="" />
            </div> 
            {/* <div className="py-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => setTabIndex(3)}
            >
              訂單
              <div className="flex-1"></div>
              <img src={require('../../assets/image/icon25.png')}
                className={`${tabIndex === 3 ? 'block' : 'hidden'} w-[18px]`}
                alt="" />
            </div> */}
            {/* <div className="py-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => setTabIndex(4)}
            >
              地址
              <div className="flex-1"></div>
              <img src={require('../../assets/image/icon25.png')}
                className={`${tabIndex === 4 ? 'block' : 'hidden'} w-[18px]`}
                alt="" />
            </div> */}
            <div className="py-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => setTabIndex(6)}
            >
              錢包
              <div className="flex-1"></div>
              <img src={require('../../assets/image/icon25.png')}
                className={`${tabIndex === 6 ? 'block' : 'hidden'} w-[18px]`}
                alt="" />
            </div>
            <div className="py-[18px] text-[#2d634e] text-[16px] font-[500] flex items-center cursor-pointer"
              style={{ borderBottom: '1px solid #0003' }}
              onClick={() => {
                showLoding(true);
                AuthLogout().then(res => {
                  dispatch(
                    createLoginSuccessAction(
                      '',
                      ''
                    )
                  );
                  localStorage.removeItem('token');
                  message.success('登出成功');
                  navigate('/login')
                  showLoding(false);
                }).catch(err => {
                  showLoding(false);
                })
              }
              }
            >
              登出
              <div className="flex-1"></div>
            </div>
          </div>
          <div className="flex-1 pl-[20px] h5:pl-[0px] h5:w-full h5:pt-[50px]">
            {
              tabIndex === 0 ?
                <SlefData />
                :
                tabIndex === 1 ?
                  <MyShop /> :
                  tabIndex === 5 ?
                    <ShopAdmin /> :
                tabIndex === 3 ?
                  <MyOrder /> :
                  tabIndex === 4 ?
                        <MyAddress /> :
                        tabIndex === 6 ?
                          <MyWallet />
                    : ''
            }
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
